<template>
    <div class="maskbg">
        <div class="dialog kjs">
            <div class="head">
                <div class="kjs_close" @click="handleClose"><span class="el-icon-close"></span></div>
                <div class="title">{{info.title}}</div>
            </div>
            <div class="bottom"></div>
            <div class="top">
                <span :class="{'active':active=='intro'}" @click="scrollToSection('intro')">立项简介</span>
                <span :class="{'active':active=='bj'}" @click="scrollToSection('bj')">项目背景与意义</span>
                <span :class="{'active':active=='mb'}" @click="scrollToSection('mb')">项目目标</span>
                <span :class="{'active':active=='jz'}" @click="scrollToSection('jz')">项目进展</span>
                <span :class="{'active':active=='cg'}" @click="scrollToSection('cg')">项目成果</span>
                <span :class="{'active':active=='sp'}" @click="scrollToSection('sp')">项目相关视频</span>
            </div>
            <div class="main" ref="main">
                <div class="intro" ref="intro">
                    <p>{{info.intro}}</p>
                </div>
                <div class="intro" ref="bj">
                    <h3>项目背景与意义</h3>
                    <p>{{info.bj}}</p>
                </div>
                <div class="intro" ref="mb">
                    <h3>项目目标</h3>
                    <p>{{info.mb}}</p>
                </div>
                <div class="intro" ref="jz">
                    <h3>项目进展</h3>
                    <p>{{info.jz}}</p>
                </div>
                <div class="intro" ref="cg">
                    <h3>项目成果</h3>
                    <p>{{info.cg}}</p>
                </div>
                <div class="intro" ref="sp">
                    <h3>项目相关视频</h3>
                    <video v-for="item in info.sp" :key="item.videoUrl" :src="item.videoUrl" controls class="video">
                        Your browser does not support the video tag.
                    </video>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
export default {
    components: {},
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        info: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            active: 'intro',
            scrollHeight: 0
        }
    },
    created() {
    },
    mounted() {
        const container = this.$refs.main;
        this.scrollHeight = container.scrollHeight
    },
    watch: {
        scrollHeight:{
            handler(val){
                
            }
        }
    },
    methods: {
        scrollToSection(refName) {
            this.active = refName
            const target = this.$refs[refName];
            const container = this.$refs.main; // 弹窗内的滚动容器
            if (target && container) {
                const targetTop = target.offsetTop - 240;
                console.log(targetTop)
                // 平滑滚动到该位置
                container.scrollTo({
                    top: targetTop,
                    behavior: 'smooth'
                });
            }
        },
        handleClose(){
            this.$emit('update:visible', false)
        }
    }
}
</script>

<style lang="less" scoped>
@import '@/styles/common';
@import '@/styles/dialog';
.video{
    width: 100%;
    margin-top: 20px;
}
</style>